import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { CadCadastroAnexoOnline } from '../interfaces/cad-cadastro-anexo-online';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';
import { CadArquivoOnline } from '../interfaces/cad-arquivo-online';

@Injectable({
  providedIn: 'root'
})
export class CadArquivoOnlineService {

  readonly path = '/arquivo/online';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  getCadCadastroAnexo(id: number, generatePresignedUrl = false){
    return this.http.get<CadCadastroAnexoOnline>(`${this.jwtAuthService.apiUrl+ this.path}/${id}?generatePresignedUrl=${generatePresignedUrl}`); 
  }

  getCadCadastroAnexoOnlinePageDeleted(page?: number, size?: number, 
    order?: string, direction?: string): Observable<PageResult<CadArquivoOnline>> {
    return this.http.get<PageResult<CadArquivoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get/deleted?page=${page}&size=${size}&order=${order}&direction=${direction}`);
  }

  getCadCadastroAnexoOnlinePageSearch(search:string, cadastroId: number, page?: number,
     size?: number, order?: string, direction?: string): Observable<PageResult<CadArquivoOnline>> {
    return this.http.get<PageResult<CadArquivoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get/deleted?search=${search}&page=${page}&size=${size}&order=${order}&direction=${direction}`);
  }

  downloadAnexo(anexoId: number ): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/download/${anexoId}`
    , {responseType: 'arraybuffer'});
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/limpar/${id}`);
  }

  getCadCadastroAnexoByUuid(uuid: string, getFileAsBase64 = false){
    return this.http.get<CadCadastroAnexoOnline>(`${this.jwtAuthService.apiUrl+ this.path}/${uuid}/${getFileAsBase64}`); 
  }

  limparTodos(): BehaviorSubject<any> {
    let eventSource: EventSource;
    const subject : BehaviorSubject<any>  = new BehaviorSubject<any>(null);
    const url = this.jwtAuthService.apiUrl + this.path;
    const token = this.jwtAuthService.getJwtTokenByUrl(url);
    eventSource = new EventSource(`${url}/limpar/todos?token=` + token);
    eventSource.addEventListener('message', message => {
      subject.next(message.data);
    });
    return subject;
  }


  //read an event stream as text from the server
  getEventStream(uuid: string): BehaviorSubject<any> {
    let eventSource: EventSource;
    const subject : BehaviorSubject<any>  = new BehaviorSubject<any>(null);

    const url = this.jwtAuthService.apiUrl + this.path;
    const token = this.jwtAuthService.getJwtTokenByUrl(url);
    // initialize the event source with the url and the headers
    eventSource = new EventSource(`${url}/task?uuid=${uuid}&token=` + token);


    eventSource.addEventListener('message', message => {
      subject.next(message.data);
    });

    return subject;
  }

}

